export const STATIC_PREFIX = process.env.PATH_PREFIX || '';